export default () => {
    const extensions = () => ({
        onSetNodeData(node, oldData) {
        },
    })

    return {extensions}
}
